// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.bs.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.bs.js");
var Select = require("@mui/material/Select").default;
var MM_cmp_pe_frame_list = require("./MM_cmp_pe_frame_list.bs.js");
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var FilterAlt = require("@mui/icons-material/FilterAlt").default;
var FilterAltOff = require("@mui/icons-material/FilterAltOff").default;

function propsAreSame(a, b) {
  return a.preCtxData === b.preCtxData;
}

var make = React.memo((function (param) {
        var openCtxSelector = param.openCtxSelector;
        var preCtxData = param.preCtxData;
        var settings = preCtxData.settingsV.val;
        var preCtx = preCtxData.ctxV.val;
        var match = React.useState(function () {
              return preCtxData.ctxV.ver;
            });
        var setPreCtxVer = match[1];
        var match$1 = React.useState(function () {
              return MM_wrk_settings.settingsGetTypeColors(settings);
            });
        var setTypeColors = match$1[1];
        var match$2 = React.useState(function () {
              return [];
            });
        var setAllLabels = match$2[1];
        var allLabels = match$2[0];
        var match$3 = React.useState(function () {
              return [];
            });
        var setFilteredLabels = match$3[1];
        var match$4 = React.useState(function () {
              
            });
        var setIsAxiomFilter = match$4[1];
        var isAxiomFilter = match$4[0];
        var match$5 = React.useState(function () {
              return "";
            });
        var setLabelFilter = match$5[1];
        var labelFilter = match$5[0];
        var match$6 = React.useState(function () {
              return "";
            });
        var setPatternFilterStr = match$6[1];
        var patternFilterStr = match$6[0];
        var match$7 = React.useState(function () {
              
            });
        var setPatternFilterErr = match$7[1];
        var patternFilterErr = match$7[0];
        var match$8 = React.useState(function () {
              return false;
            });
        var setApplyFiltersRequested = match$8[1];
        var applyFiltersRequested = match$8[0];
        var match$9 = React.useState(function () {
              return false;
            });
        var setMainMenuIsOpened = match$9[1];
        var mainMenuIsOpened = match$9[0];
        var mainMenuButtonRef = React.useRef(null);
        var actClearFilters = function (applyFilters) {
          Curry._1(setIsAxiomFilter, (function (param) {
                  
                }));
          Curry._1(setLabelFilter, (function (param) {
                  return "";
                }));
          Curry._1(setPatternFilterStr, (function (param) {
                  return "";
                }));
          Curry._1(setPatternFilterErr, (function (param) {
                  
                }));
          if (applyFilters) {
            return Curry._1(setApplyFiltersRequested, (function (param) {
                          return true;
                        }));
          }
          
        };
        var actApplyFilters = function (param) {
          var patternFilterSyms = Common.getSpaceSeparatedValuesAsArray(patternFilterStr);
          var incorrectSymbol = patternFilterSyms.find(function (sym) {
                return !MM_context.isConst(preCtxData.ctxV.val, sym);
              });
          if (incorrectSymbol !== undefined) {
            return Curry._1(setPatternFilterErr, (function (param) {
                          return "'" + incorrectSymbol + "' - is not a constant.";
                        }));
          }
          Curry._1(setPatternFilterErr, (function (param) {
                  
                }));
          var patternFilterInts = MM_context.ctxSymsToIntsExn(preCtxData.ctxV.val, patternFilterSyms);
          Curry._1(setFilteredLabels, (function (param) {
                  return allLabels.filter(function (param) {
                              var label = param[1];
                              var frame = MM_context.getFrameExn(preCtxData.ctxV.val, label);
                              if (Belt_Option.mapWithDefault(isAxiomFilter, true, (function (isAxiomFilter) {
                                        return isAxiomFilter === frame.isAxiom;
                                      })) && label.toLowerCase().includes(labelFilter.toLowerCase())) {
                                return MM_wrk_search_asrt.frameMatchesPattern(frame, patternFilterInts);
                              } else {
                                return false;
                              }
                            });
                }));
        };
        React.useEffect((function () {
                if (applyFiltersRequested) {
                  Curry._1(setApplyFiltersRequested, (function (param) {
                          return false;
                        }));
                  actApplyFilters(undefined);
                }
                
              }), [applyFiltersRequested]);
        var actPreCtxDataChanged = function (param) {
          var settings = preCtxData.settingsV.val;
          Curry._1(setTypeColors, (function (param) {
                  return MM_wrk_settings.settingsGetTypeColors(settings);
                }));
          var preCtx = preCtxData.ctxV.val;
          Curry._1(setPreCtxVer, (function (param) {
                  return preCtxData.ctxV.ver;
                }));
          var allLabels = MM_context.getAllFrameLabels(preCtx).map(function (label, i) {
                return [
                        i + 1 | 0,
                        label
                      ];
              });
          Curry._1(setAllLabels, (function (param) {
                  return allLabels;
                }));
          Curry._1(setFilteredLabels, (function (param) {
                  return allLabels;
                }));
          actClearFilters(false);
        };
        React.useEffect((function () {
                actPreCtxDataChanged(undefined);
              }), [preCtxData]);
        var isAxiomFilterToStr = function (typeFilter) {
          if (typeFilter !== undefined) {
            if (typeFilter) {
              return "true";
            } else {
              return "false";
            }
          } else {
            return "none";
          }
        };
        var actIsAxiomFilterUpdated = function (isAxiomStr) {
          Curry._1(setIsAxiomFilter, (function (param) {
                  switch (isAxiomStr) {
                    case "false" :
                        return false;
                    case "true" :
                        return true;
                    default:
                      return ;
                  }
                }));
        };
        var actLabelFilterUpdated = function (newLabelFilter) {
          Curry._1(setLabelFilter, (function (param) {
                  return newLabelFilter;
                }));
        };
        var actPatternFilterStrUpdated = function (newPatternFilterStr) {
          Curry._1(setPatternFilterStr, (function (param) {
                  return newPatternFilterStr;
                }));
        };
        React.useEffect((function () {
                actApplyFilters(undefined);
              }), [isAxiomFilter]);
        var actCloseMainMenu = function (param) {
          Curry._1(setMainMenuIsOpened, (function (param) {
                  return false;
                }));
        };
        var rndIsAxiomFilter = function (param) {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "isAxiomFilter-label",
                          children: "Assertion type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "isAxiomFilter-label",
                          label: "Assertion type",
                          value: isAxiomFilterToStr(isAxiomFilter),
                          onChange: (function (param) {
                              return Expln_React_common.evt2str(actIsAxiomFilterUpdated, param);
                            }),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: "none",
                              children: "All"
                            }), React.createElement(MenuItem, {
                              value: "true",
                              children: "Axiom"
                            }), React.createElement(MenuItem, {
                              value: "false",
                              children: "Theorem"
                            })));
        };
        var rndLabelFilter = function (param) {
          return React.createElement(TextField, {
                      value: labelFilter,
                      label: "Label",
                      size: "small",
                      style: {
                        width: "200px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actLabelFilterUpdated, param);
                        }),
                      onKeyDown: (function (param) {
                          return MM_react_common.kbrdHnd(MM_react_common.keyCodeEnter, undefined, undefined, undefined, actApplyFilters, undefined, param);
                        }),
                      autoFocus: true
                    });
        };
        var rndPatternFilter = function (param) {
          return React.createElement(TextField, {
                      value: patternFilterStr,
                      label: "Pattern",
                      size: "small",
                      style: {
                        width: "300px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actPatternFilterStrUpdated, param);
                        }),
                      onKeyDown: (function (param) {
                          return MM_react_common.kbrdHnd(MM_react_common.keyCodeEnter, undefined, undefined, undefined, actApplyFilters, undefined, param);
                        })
                    });
        };
        var rndPatternError = function (param) {
          if (patternFilterErr !== undefined) {
            return React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, "Malformed pattern text: " + patternFilterErr);
          } else {
            return React.createElement(React.Fragment, undefined);
          }
        };
        var rndApplyFiltersBtn = function (param) {
          return React.createElement("span", {
                      title: "Apply filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actApplyFilters(undefined);
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAlt, {}))
                        }));
        };
        var rndClearFiltersBtn = function (param) {
          return React.createElement("span", {
                      title: "Clear filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actClearFilters(true);
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAltOff, {}))
                        }));
        };
        var rndMainMenuBtn = function (param) {
          return React.createElement("span", {
                      ref: Caml_option.some(mainMenuButtonRef),
                      title: "Additional actions"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              Curry._1(setMainMenuIsOpened, (function (param) {
                                      return true;
                                    }));
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(Menu, {}))
                        }));
        };
        var rndFilters = function (param) {
          return React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, rndIsAxiomFilter(undefined), rndLabelFilter(undefined), rndPatternFilter(undefined), rndApplyFiltersBtn(undefined), rndClearFiltersBtn(undefined), rndMainMenuBtn(undefined));
        };
        var rndMainMenu = function (param) {
          if (!mainMenuIsOpened) {
            return React.createElement(React.Fragment, undefined);
          }
          var mainMenuButtonRef$1 = mainMenuButtonRef.current;
          if (mainMenuButtonRef$1 == null) {
            return React.createElement(React.Fragment, undefined);
          } else {
            return React.createElement(Expln_React_Menu.make, {
                        opn: true,
                        anchorEl: Caml_option.some(mainMenuButtonRef$1),
                        onClose: actCloseMainMenu,
                        children: Caml_option.some(React.createElement(MenuItem, {
                                  onClick: (function (param) {
                                      Curry._1(setMainMenuIsOpened, (function (param) {
                                              return false;
                                            }));
                                      Belt_Option.forEach(Caml_option.nullable_to_opt(openCtxSelector.current), (function (openCtxSelector) {
                                              Curry._1(openCtxSelector, undefined);
                                            }));
                                    }),
                                  children: "Show context"
                                }))
                      });
          }
        };
        return React.createElement(Expln_React_Column.make, {
                    style: {
                      margin: "15px"
                    },
                    children: Caml_option.some(null)
                  }, rndFilters(undefined), rndPatternError(undefined), rndMainMenu(undefined), JsxPPXReactSupport.createElementWithKey("" + String(match[0]) + "", MM_cmp_pe_frame_list.make, {
                        modalRef: param.modalRef,
                        typeColors: match$1[0],
                        editStmtsByLeftClick: settings.editStmtsByLeftClick,
                        preCtx: preCtx,
                        frms: preCtxData.frms,
                        parenCnt: preCtxData.parenCnt,
                        syntaxTypes: preCtxData.syntaxTypes,
                        labels: match$3[0],
                        openFrameExplorer: param.openFrameExplorer
                      }));
      }), propsAreSame);

exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
